import React from 'react';

import { IGenealogiaDto } from '@dinnisoft/esteio-gestao-common';
import { Tooltip } from '@mui/material';

import * as S from './styles';

interface GenealogiaProps {
  genealogia: IGenealogiaDto;
}

const Genealogia: React.FC<GenealogiaProps> = ({ genealogia }: GenealogiaProps) => {
  return (
    <S.Container>
      {/* Filho */}
      <S.ItemContainer>
        <Tooltip title={genealogia.animal ?? ''} followCursor placement="top">
          <S.ItemBox isEmpty={!genealogia.animal}>
            <S.ItemBoxText>{genealogia.animal}</S.ItemBoxText>
          </S.ItemBox>
        </Tooltip>
        <S.HorizontalLine width={25} />
      </S.ItemContainer>

      <div>
        <S.ParentescoContainer>
          <S.VerticalLineContainer>
            <S.Span height={68} />
            <S.VerticalLineTop height={68.5} />
          </S.VerticalLineContainer>

          {/* Pai */}
          <S.ItemContainer>
            <Tooltip title={genealogia.pai ?? ''} followCursor placement="top">
              <S.ItemBox isEmpty={!genealogia.pai}>
                <S.ItemBoxText>{genealogia.pai}</S.ItemBoxText>
              </S.ItemBox>
            </Tooltip>
          </S.ItemContainer>

          <S.HorizontalLine width={125} />

          <div>
            <S.ParentescoContainer>
              <S.VerticalLineContainer>
                <S.Span height={33.5} />
                <S.VerticalLineTop height={33.5} />
              </S.VerticalLineContainer>

              {/* Avô paterno */}
              <S.ItemContainer>
                <Tooltip title={genealogia.avoPaterno ?? ''} followCursor placement="top">
                  <S.ItemBox isEmpty={!genealogia.avoPaterno}>
                    <S.ItemBoxText>{genealogia.avoPaterno}</S.ItemBoxText>
                  </S.ItemBox>
                </Tooltip>
              </S.ItemContainer>

              <S.HorizontalLine width={125} />

              <div>
                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.Span height={16.5} />
                    <S.VerticalLineTop height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Pai do avô paterno */}
                  <S.ItemContainer>
                    <Tooltip title={genealogia.avoPaternoBisavo ?? ''} followCursor placement="top">
                      <S.ItemBox isEmpty={!genealogia.avoPaternoBisavo}>
                        <S.ItemBoxText>{genealogia.avoPaternoBisavo}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>

                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.VerticalLineBottom height={16.5} />
                    <S.Span height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Mãe do avô paterno */}
                  <S.ItemContainer>
                    <Tooltip
                      title={genealogia.avoPaternoBisavoh ?? ''}
                      followCursor
                      placement="top"
                    >
                      <S.ItemBox isEmpty={!genealogia.avoPaternoBisavoh}>
                        <S.ItemBoxText>{genealogia.avoPaternoBisavoh}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>
              </div>
            </S.ParentescoContainer>

            <S.ParentescoContainer>
              <S.VerticalLineContainer>
                <S.VerticalLineBottom height={33.5} />
                <S.Span height={33.5} />
              </S.VerticalLineContainer>

              {/* Avó paterna */}
              <S.ItemContainer>
                <Tooltip title={genealogia.avohPaterna ?? ''} followCursor placement="top">
                  <S.ItemBox isEmpty={!genealogia.avohPaterna}>
                    <S.ItemBoxText>{genealogia.avohPaterna}</S.ItemBoxText>
                  </S.ItemBox>
                </Tooltip>
              </S.ItemContainer>

              <S.HorizontalLine width={125} />

              <div>
                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.Span height={16.5} />
                    <S.VerticalLineTop height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Pai da avó do pai */}
                  <S.ItemContainer>
                    <Tooltip
                      title={genealogia.avohPaternaBisavo ?? ''}
                      followCursor
                      placement="top"
                    >
                      <S.ItemBox isEmpty={!genealogia.avohPaternaBisavo}>
                        <S.ItemBoxText>{genealogia.avohPaternaBisavo}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>

                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.VerticalLineBottom height={16.5} />
                    <S.Span height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Mãe da avó do pai */}
                  <S.ItemContainer>
                    <Tooltip
                      title={genealogia.avohPaternaBisavoh ?? ''}
                      followCursor
                      placement="top"
                    >
                      <S.ItemBox isEmpty={!genealogia.avohPaternaBisavoh}>
                        <S.ItemBoxText>{genealogia.avohPaternaBisavoh}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>
              </div>
            </S.ParentescoContainer>
          </div>
        </S.ParentescoContainer>

        <S.ParentescoContainer>
          <S.VerticalLineContainer>
            <S.VerticalLineBottom height={68.5} />
            <S.Span height={68} />
          </S.VerticalLineContainer>

          {/* Mãe */}
          <S.ItemContainer>
            <Tooltip title={genealogia.mae ?? ''} followCursor placement="top">
              <S.ItemBox isEmpty={!genealogia.mae}>
                <S.ItemBoxText>{genealogia.mae}</S.ItemBoxText>
              </S.ItemBox>
            </Tooltip>
          </S.ItemContainer>

          <S.HorizontalLine width={125} />

          <div>
            <S.ParentescoContainer>
              <S.VerticalLineContainer>
                <S.Span height={33.5} />
                <S.VerticalLineTop height={33.5} />
              </S.VerticalLineContainer>

              {/* Avô materno */}
              <S.ItemContainer>
                <Tooltip title={genealogia.avoMaterno ?? ''} followCursor placement="top">
                  <S.ItemBox isEmpty={!genealogia.avoMaterno}>
                    <S.ItemBoxText>{genealogia.avoMaterno}</S.ItemBoxText>
                  </S.ItemBox>
                </Tooltip>
              </S.ItemContainer>

              <S.HorizontalLine width={125} />

              <div>
                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.Span height={16.5} />
                    <S.VerticalLineTop height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Pai do avô materno */}
                  <S.ItemContainer>
                    <Tooltip title={genealogia.avoMaternoBisavo ?? ''} followCursor placement="top">
                      <S.ItemBox isEmpty={!genealogia.avoMaternoBisavo}>
                        <S.ItemBoxText>{genealogia.avoMaternoBisavo}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>

                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.VerticalLineBottom height={16.5} />
                    <S.Span height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Mãe do avô paterno */}
                  <S.ItemContainer>
                    <Tooltip
                      title={genealogia.avoMaternoBisavoh ?? ''}
                      followCursor
                      placement="top"
                    >
                      <S.ItemBox isEmpty={!genealogia.avoMaternoBisavoh}>
                        <S.ItemBoxText>{genealogia.avoMaternoBisavoh}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>
              </div>
            </S.ParentescoContainer>

            <S.ParentescoContainer>
              <S.VerticalLineContainer>
                <S.VerticalLineBottom height={33.5} />
                <S.Span height={33.5} />
              </S.VerticalLineContainer>

              {/* Avó materna */}
              <S.ItemContainer>
                <Tooltip title={genealogia.avohMaterna ?? ''} followCursor placement="top">
                  <S.ItemBox isEmpty={!genealogia.avohMaterna}>
                    <S.ItemBoxText>{genealogia.avohMaterna}</S.ItemBoxText>
                  </S.ItemBox>
                </Tooltip>
              </S.ItemContainer>

              <S.HorizontalLine width={125} />

              <div>
                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.Span height={16.5} />
                    <S.VerticalLineTop height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Pai da avó materna */}
                  <S.ItemContainer>
                    <Tooltip
                      title={genealogia.avohMaternaBisavo ?? ''}
                      followCursor
                      placement="top"
                    >
                      <S.ItemBox isEmpty={!genealogia.avohMaternaBisavo}>
                        <S.ItemBoxText>{genealogia.avohMaternaBisavo}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>

                <S.ParentescoContainer>
                  <S.VerticalLineContainer>
                    <S.VerticalLineBottom height={16.5} />
                    <S.Span height={16.5} />
                  </S.VerticalLineContainer>

                  {/* Mãe da avó */}
                  <S.ItemContainer>
                    <Tooltip
                      title={genealogia.avohMaternaBisavoh ?? ''}
                      followCursor
                      placement="top"
                    >
                      <S.ItemBox isEmpty={!genealogia.avohMaternaBisavoh}>
                        <S.ItemBoxText>{genealogia.avohMaternaBisavoh}</S.ItemBoxText>
                      </S.ItemBox>
                    </Tooltip>
                  </S.ItemContainer>
                </S.ParentescoContainer>
              </div>
            </S.ParentescoContainer>
          </div>
        </S.ParentescoContainer>
      </div>
    </S.Container>
  );
};

export default Genealogia;
